import { useState, useCallback } from 'react';
import { Messages } from '../constants/Messages';

export const useErrorHandling = () => {
    const [errorDialogOpen, setErrorDialogOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [errorKeywordId, setErrorKeywordId] = useState<number | null>(null);
    const [isErrorKeywordExcluded, setIsErrorKeywordExcluded] = useState<boolean | null>(null);
    const [isErrorState, setIsErrorState] = useState<boolean>(false);
    const [previousKeyword, setPreviousKeyword] = useState<string>('');
    const [errorHandled, setErrorHandled] = useState(false);

    const handleCloseErrorDialog = useCallback(() => {
        setErrorDialogOpen(false);
        setErrorHandled(false);
    }, []);

    const handleError = useCallback((message: string, id: number | null, isExcluded: boolean | null) => {
        if (!errorHandled) {
            setErrorMessage(message);
            setErrorDialogOpen(true);
            setErrorKeywordId(id);
            setIsErrorKeywordExcluded(isExcluded);
            setIsErrorState(true);
            setErrorHandled(true);
        }
    }, [errorHandled]);

    const handleEmptyKeywordError = useCallback((id: number | null, isExcluded: boolean | null) => {
        handleError(Messages.EMPTY_KEYWORD, id, isExcluded);
    }, [handleError]);

    const handleDuplicateKeywordError = useCallback((id: number | null, isExcluded: boolean | null, location: string) => {
        handleError(`${Messages.DUPLICATE_KEYWORD} (${location})`, id, isExcluded);
    }, [handleError]);

    const handleInvalidCharacterError = useCallback((id: number | null, isExcluded: boolean | null) => {
        handleError(Messages.INVALID_CHARACTER_ERROR, id, isExcluded);
    }, [handleError]);

    return {
        errorDialogOpen,
        errorMessage,
        errorKeywordId,
        isErrorKeywordExcluded,
        isErrorState,
        previousKeyword,
        handleCloseErrorDialog,
        handleEmptyKeywordError,
        handleDuplicateKeywordError,
        handleInvalidCharacterError,
        setPreviousKeyword,
        setErrorKeywordId,
        setIsErrorKeywordExcluded,
        setIsErrorState,
        setErrorHandled
    };
};